import React from "react";

//Shows YouTube's thumbnail and only loads the player when clicked (faster, and no YouTube cookies until then)
const YouTube = ({ id, title }) => {
  const [isPlaying, setIsPlaying] = React.useState(false);

  if (isPlaying) {
    return (
      <div className={"youtube"}>
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type={"button"}
      className={"youtube"}
      onClick={() => setIsPlaying(true)}
      aria-label={`Play video: ${title}`}
    >
      <img
        src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
        alt={""}
        loading={"lazy"}
      />
      <svg
        className={"youtube-play"}
        viewBox={"0 0 68 48"}
        aria-hidden={"true"}
      >
        <path
          d={"M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"}
          fill={"#f00"}
        />
        <path
          d={"M45 24L27 14v20"}
          fill={"#fff"}
        />
      </svg>
    </button>
  );
};

export default YouTube;
